import {
  SEND_CAMPAIGN,
  SEND_CAMPAIGN_FAILED,
  DELETE_CAMPAIGN_SUCCESSFUL,
  DELETE_CAMPAIGN_FAILED,
  DRAFT_CAMPAIGN
} from "./types";

export const sendCampaign = (campaign, props) => async dispatch => {
  try {
    if (campaign.id) {
      await props.firestore
        .collection("campaigns")
        .doc(campaign.id)
        .update({
          body: campaign.html,
          design: JSON.stringify(campaign.design),
          title: campaign.title,
          subject: campaign.subject,
          status: "sent"
        });

      await props.firestore
        .collection("campaigns")
        .doc(campaign.id)
        .collection("recipients")
        .doc("contacts")
        .set({
          emails: campaign.recipients
        });
    } else {
      const cam = await props.firestore.collection("campaigns").add({
        body: campaign.html,
        design: JSON.stringify(campaign.design),
        subject: campaign.subject,
        title: campaign.title,
        userId: campaign.userId,
        createdAt: props.firestore.FieldValue.serverTimestamp(),
        status: "sent"
      });

      await props.firestore
        .collection("campaigns")
        .doc(cam.id)
        .collection("recipients")
        .doc("contacts")
        .set({
          emails: campaign.recipients
        });
    }

    dispatch({ type: SEND_CAMPAIGN, campaign });
    window.location.reload();
  } catch (err) {
    console.log(err);
    dispatch({ type: SEND_CAMPAIGN_FAILED, err });
  }
};

export const onDraft = (campaign, props) => async (getState, dispatch) => {
  const db = props.firestore;

  try {
    if (campaign.id) {
      await props.firestore
        .collection("campaigns")
        .doc(campaign.id)
        .update({
          body: campaign.html,
          design: JSON.stringify(campaign.design),
          subject: campaign.subject,
          title: campaign.title
        });
    } else {
      await db.collection("campaigns").add({
        body: campaign.html,
        design: JSON.stringify(campaign.design),
        subject: campaign.subject,
        title: campaign.title,
        userId: campaign.userId,
        createdAt: props.firestore.FieldValue.serverTimestamp(),
        status: "draft"
      });
    }

    dispatch({ type: DRAFT_CAMPAIGN, campaign });
    window.location.reload();
  } catch (err) {
    console.error(err);
  }
};

export const deleteCampaign = (campaign, props) => async dispatch => {
  const db = props.firestore;

  try {
    await db
      .collection("campaigns")
      .doc(campaign)
      .delete();

    await db
      .collection("campaigns")
      .doc(campaign)
      .collection("recipients")
      .doc("contacts")
      .delete();

    dispatch({ type: DELETE_CAMPAIGN_SUCCESSFUL });
  } catch (err) {
    dispatch({ type: DELETE_CAMPAIGN_FAILED, err });
  }
};
